export function briefPiecesJointesFromVente(vente) {
  return vente?.brief_pieces_jointes ?? [];
}

export function formatBriefFileSize(bytes) {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size <= 0) return '—';
  if (size < 1024) return `${size} o`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} Ko`;
  return `${(size / (1024 * 1024)).toFixed(1)} Mo`;
}

export const BRIEF_ACCEPTED_FILE_TYPES = [
  'image/*',
  'video/*',
  'text/plain',
  'text/csv',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.zip',
].join(',');
